import React from 'react';

export default class BaseModalComponent extends React.Component {
  constructor(props) {
    super(props);
    [
      'handleFormClean',
      'showModal',
      'hideModal',
    ].map(method => this[method] = this[method].bind(this));
  }

  /**
   * Modal中直接包含Form组件的重置操作
   */
  handleFormClean() {
    if (this.formRef) {
      this.formRef.resetFields();
    }
  }

  showModal() {
    this.setState({ visible: true });
  }

  hideModal() {
    this.setState({ visible: false });
  }
}
